export const DASHBOARD_REDUCER_KEY = 'dashboardReducer';

export const LOAD_DASHBOARD = 'LOAD_DASHBOARD';
export const SET_DASHBOARD_ERROR = 'SET_DASHBOARD_ERROR';

/* DEFAULT DASHBOARD STATE */
let defaultState = {
  dashboard: {
    activeCampaignsCount: undefined,
    completedCampaignsCount: undefined,
    influencerCount: undefined,
    influencerFollowerCount: undefined,
    completedCampaigns: [],
  },
};

/* REDUCER */
export default function(state = defaultState, action = {}) {
  switch (action.type) {
    case LOAD_DASHBOARD: {
      return {
        ...state,
        dashboard: action.payload,
      };
    }
    case SET_DASHBOARD_ERROR: {
      //TODO
      return state;
    }
    default:
      return state;
  }
}

export const selectDashboard = (state) => {
  return state[DASHBOARD_REDUCER_KEY].dashboard;
};
